import { render, staticRenderFns } from "./FoliacionAceite.vue?vue&type=template&id=afd5bdaa&scoped=true&"
import script from "./FoliacionAceite.vue?vue&type=script&lang=js&"
export * from "./FoliacionAceite.vue?vue&type=script&lang=js&"
import style0 from "./FoliacionAceite.vue?vue&type=style&index=0&id=afd5bdaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd5bdaa",
  null
  
)

export default component.exports